import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  top: 30px;
  z-index: 1;
`;

const Background = ({ themeColor }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1890.8 1393.1">
    <defs>
      <clipPath id="j">
        <path d="M1452.7 709.88h-211.92v7.697h211.92z" />
      </clipPath>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1240.8 713.72)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="i">
        <path d="M1452.7 272.92h-211.92v7.696h211.92z" />
      </clipPath>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1240.8 276.77)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="h">
        <path d="M177.96 542.77H89.208l-5.535 98.901h98.9z" />
      </clipPath>
      <linearGradient
        id="g"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 133.12 542.77)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="o">
        <path d="M177.96 472.11H89.208l-5.535 98.901h98.9z" />
      </clipPath>
      <linearGradient
        id="f"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 133.12 472.11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="n">
        <path d="M177.96 403.33H89.208l-5.535 98.9h98.9z" />
      </clipPath>
      <linearGradient
        id="e"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 133.12 403.33)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="m">
        <path d="M177.96 332.89H89.208l-5.535 98.899h98.9z" />
      </clipPath>
      <linearGradient
        id="d"
        x2="1"
        gradientTransform="matrix(0 98.9 98.9 0 133.12 332.89)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="l">
        <path d="M0 1500h1500V0H0z" />
      </clipPath>
      <clipPath id="k">
        <path d="M923.63 721.96H545.75v212.56h377.88z" />
      </clipPath>
      <linearGradient
        id="c"
        x2="1"
        gradientTransform="scale(378.6 -378.6) rotate(33.01 4.89 1.407)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.036" stopColor="#282827" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.552" stopColor="#282827" />
        <stop offset="0.634" stopColor="#282827" />
        <stop offset="0.754" stopColor="#282827" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
    </defs>
    <path
      fill="#e5e4e3"
      d="M0 0h-487.63l-247.02-336H245.6z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9) translate(979.21 595.96)"
    />
    <path
      fill="#d8d7d6"
      d="M1224.5 229.35H244.96v30.61h979.54z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <path
      fill={themeColor || '#fe9a21'}
      d="M1446.8 279.88h-200v430h200z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <g
      clipPath="url(#j)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path fill="url(#b)" d="M1452.7 709.88h-211.92v7.697h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1241.2 706.18h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <path
      fill="#515050"
      d="M1456.6 706.18h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <g
      clipPath="url(#i)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path fill="url(#a)" d="M1452.7 272.92h-211.92v7.696h211.92z" />
    </g>
    <path
      fill="#282827"
      d="M1241.2 269.23h-3.83v15.096h3.83z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <path
      fill="#515050"
      d="M1456.6 269.23h-3.829v15.096h3.829z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <path
      fill="#404041"
      d="M0 0h-158.63l14.76 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9) translate(212.71 277.41)"
    />
    <path
      fill="#bbbdbf"
      d="M0 0h-111.58l-9.226 378.74h130.96z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9) translate(189.64 277.41)"
    />
    <g
      clipPath="url(#h)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path
        fill="url(#g)"
        d="M177.96 542.77H89.208l-5.535 98.901h98.9z"
      />
    </g>
    <g
      clipPath="url(#o)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path
        fill="url(#f)"
        d="M177.96 472.11H89.208l-5.535 98.901h98.9z"
      />
    </g>
    <g
      clipPath="url(#n)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path fill="url(#e)" d="M177.96 403.33H89.208l-5.535 98.9h98.9z" />
    </g>
    <g
      clipPath="url(#m)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path
        fill="url(#d)"
        d="M177.96 332.89H89.208l-5.535 98.899h98.9z"
      />
    </g>
    <path
      fill="#404041"
      d="M227.81 270.23H38.44v14.367h189.37z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <g
      clipPath="url(#l)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path
        fill="#efefef"
        d="M0 0l-24.621 29.981v520.67c0 31.022-34.447 64.923-65.47 64.923h-447.38c-31.022 0-70.941-33.901-70.941-64.923V30.691L-629.75-.001l-10.396 5.876-11.489 7.282v516.54c0 67.976 55.107 123.08 123.08 123.08h426.81c67.976 0 123.08-55.107 123.08-123.08"
        transform="translate(1049.8 467.84)"
      />
      <path
        fill={themeColor || '#fe9a21'}
        d="M0 0v-531.42h-21.338V-.06c0 54.846-45.089 99.305-100.71 99.305h-428.33c-55.622 0-100.71-44.459-100.71-99.305v-531.36h-21.885V0c0 67.026 55.107 121.36 123.08 121.36h426.81C-55.106 121.36-.003 67.022-.003 0"
        transform="translate(1071.2 999.25)"
      />
      <path
        fill="none"
        stroke="#f9f9f9"
        strokeMiterlimit="10"
        strokeWidth="9"
        d="M0 0v531.47c0 60.747 49.942 109.99 111.55 109.99h427.44c61.608 0 111.55-49.245 111.55-109.99V0"
        transform="translate(409.69 467.83)"
      />
      <path
        fill="#efefef"
        d="M0 0l-31.979 43.431v671.75c0 40.292-44.74 84.321-85.032 84.321h-581.06c-40.292 0-92.139-44.029-92.139-84.321V37.731L-817.924-.005l-13.502 7.631-14.923 9.459v670.88c0 88.287 71.574 159.86 159.86 159.86h554.34c88.287 0 159.86-71.574 159.86-159.86"
        transform="translate(1144 331.16)"
      />
      <path
        fill={themeColor || '#fe9a21'}
        d="M0 0v-690.21h-27.714V-.07c0 71.232-58.562 128.98-130.8 128.98h-556.31c-72.241 0-130.8-57.745-130.8-128.98v-690.14h-28.425V0c0 87.054 71.574 157.63 159.86 157.63h554.34C-71.562 157.63.011 87.056.011 0"
        transform="translate(1171.7 1021.4)"
      />
      <path
        fill="none"
        stroke="#f9f9f9"
        strokeMiterlimit="10"
        strokeWidth="12"
        d="M0 0v690.27c0 78.899 64.866 142.86 144.88 142.86h555.16c80.016 0 144.88-63.959 144.88-142.86V0"
        transform="translate(312.58 331.15)"
      />
      <path
        fill={themeColor || '#fe9a21'}
        d="M0 0l580.89-.712 2.847 510.79c0 42.431-34.794 74.013-77.715 74.013H76.292c-42.921 0-77.716-28.767-77.716-71.198L-2.136.003"
        transform="translate(443.88 498.44)"
      />
    </g>
    <path
      fill={themeColor || '#ef8b1d'}
      d="M864.5 305.42H604.86v259.64H864.5z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <path
      fill={themeColor || '#f7a54b'}
      d="M0 0h-234.83l-12.403-19.019h259.64z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9) translate(852.1 584.08)"
    />
    <path
      fill="#fff"
      d="M0 0v165.08l8.233 18.988h145.27l10.688-18.988V0z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9) translate(652.59 404.45)"
    />
    <path
      fill="#eaeaea"
      d="M816.78 402.67H652.59v166.85h164.19z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <g
      clipPath="url(#k)"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    >
      <path fill="url(#c)" d="M923.63 721.96H545.75v212.56h377.88z" />
    </g>
    <path
      fill="none"
      stroke="#59595c"
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M923.63 721.96H545.75v212.56h377.88z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
    <path
      fill="#fff"
      stroke={themeColor || '#ef8b1d'}
      strokeMiterlimit="10"
      strokeWidth="7"
      d="M1026.6 1057.1H442.86v213.56h583.74z"
      transform="matrix(1.3333 0 0 -1.3333 -51.249 1698.9)"
    />
  </svg>
);

export interface BoothBackgroundProps {
  themeColor?: string;
}

const BoothBackground: React.FC<BoothBackgroundProps> = ({ themeColor }: BoothBackgroundProps) => (
  <RootContainer>
    <BackgroundContainer>
      <Background themeColor={themeColor} />
    </BackgroundContainer>
  </RootContainer>
);

export default BoothBackground;
